import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';

import moment from 'moment';
import 'moment-duration-format';

import { pageLoaded } from '../../../utils';
import CoachingSummery from '../../../components/v3/Coaching/CoachingSummery';
import CoachedAgentsTable from './CoachedAgentsTable';
import DateRangePicker from '../../../components/v3/DateRangePicker/DateRangePicker';
import { dateTimeFormat, colors } from '../../../constants';

import {
    updateProps,
    loadCoachingDashboardScreen,
} from './CoachingDashboardActions';

class CoachingDashboardScreen extends Component {
    constructor(props) {
        super(props);
        this.getTimeRangesNode = this.getTimeRangesNode.bind(this);
        //this._init = this._init.bind(this);

        //this._init();
    }

    componentDidMount() {
        pageLoaded('Coaching');

        const fromDate = moment().startOf('day').subtract(7, 'd').format(dateTimeFormat);
        const toDate = moment().endOf('day').format(dateTimeFormat);
        this.props.dispatch(updateProps({ fromDate: fromDate, toDate: toDate }));

        this.props.dispatch(loadCoachingDashboardScreen(fromDate, toDate));
    }

    //_init() {
    //    this.props.dispatch(updateProps({ startDate: startDate, endDate: endDate }));
    //}

    getTimeRangesNode() {
        const
            {
                fromDate,
                toDate,
                currentUser,
            } = this.props;

        const firstName = (currentUser && currentUser.Name) ? currentUser.Name.replace(/ .*/, '') : '';
        return (
            <div className="flex-container" style={{ marginTop: '24px' }}>
                <div>
                    <div className="title-primary-400-24-28">
                        Welcome  {firstName}!
                    </div>
                </div>
                <div className="flex-container-start">
                    <div style={{ margin: '0 0 0 20px' }}>
                        <DateRangePicker
                            fromDate={fromDate}
                            toDate={toDate}
                            onClose={this.onSelectNewTimeRange} />
                    </div>
                </div>
            </div>);
    }

    render() {
        const
            {
                coachedAgentsData,
                calibratedOnSurveyQuestions,
                coachingSummary
            } = this.props;

        const summary = (<CoachingSummery coachingSummary={coachingSummary} />);
        const coachedAgentsTable = (<CoachedAgentsTable
            calibratedOnSurveyQuestions={calibratedOnSurveyQuestions}
            coachedAgentsData={coachedAgentsData}
        />);
        const timeRangesNode = this.getTimeRangesNode();

        return (<div className="main-page-width">
            {timeRangesNode}
            <div className="flex-container" style={{ margin: '20px 0px 3px 0' }}>
                {summary}
            </div>
            <div style={{ marginTop: '20px' }}>
                {coachedAgentsTable}
            </div>
            <br />
            <br />
            <br />
        </div>)
    }
}

const select = state => ({ ...state.CoachingDashboardScreen, ...state.session });

export default connect(select)(CoachingDashboardScreen);